import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { Button } from "@utahdts/utah-design-system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useWaterSystemSearchModal } from "../../reuseableComponents/WaterSystemSearchModalContext";
import useDwriData from "../../../hooks/engineering/water_use/useDwriData";
import DwriTabs from "./DwriTabs";
import DwriDataTab from "./tabs/DwriDataTab";
import DwriCalculationsTab from "./tabs/DwriCalculationsTab";
import DwriReportTab from "./tabs/DwriReportTab";

const DwriDataContainer = () => {
    const history = useHistory();
    const location = useLocation();
    const { path } = useRouteMatch();

    const [activeTab, setActiveTab] = useState("dwri-data");

    // Sync active tab with URL
    useEffect(() => {
        const lastSegment = location.pathname.split("/").pop();
        if (["dwri-data", "calculations", "report"].includes(lastSegment)) {
            setActiveTab(lastSegment);
        }
    }, [location]);

    const { selectedYears = [], selectedSources = [], yearOptions = [] } = location.state || {};

    let formattedYears = selectedYears.map((year) => Number.parseInt(year, 10));
    if (formattedYears.length === 0) {
        formattedYears = [...yearOptions].sort((a, b) => b - a).slice(0, 5);
    }

    const { selectedWaterSystem } = useWaterSystemSearchModal();

    const dwriData = useDwriData({
        pwsId: selectedWaterSystem?.pwsId,
        years: formattedYears,
        selectedSources,
    });

    const handleTabChange = (tabId) => {
        history.push(`${path}/${tabId}`, location.state);
    };

    const handleBack = () => {
        history.push("/engineering/dwri/dwri-data-search");
    };

    return (
        <div className="utah-design-system page-container">
            <div className="mb-3">
                 <Button variant="secondary" onClick={handleBack}>
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back to Search
                </Button>
            </div>
            
            <DwriTabs activeTab={activeTab} onTabChange={handleTabChange} />

            {/* ARIA-compliant tab panels: always present, only one visible */}
            <div className="mt-4">
                <div
                    role="tabpanel"
                    id="tabpanel-r1-dwri-data"
                    aria-labelledby="tab-:r1:-dwri-data"
                    hidden={activeTab !== "dwri-data"}
                >
                    <DwriDataTab {...dwriData} selectedSources={selectedSources} />
                </div>
                <div
                    role="tabpanel"
                    id="tabpanel-r1-calculations"
                    aria-labelledby="tab-:r1:-calculations"
                    hidden={activeTab !== "calculations"}
                >
                    <DwriCalculationsTab
                        pwsId={selectedWaterSystem?.pwsId}
                        systemName={dwriData.systemName}
                        systemInfo={dwriData.systemInfo}
                        assignableEngineers={dwriData.assignableEngineers}
                        loading={dwriData.loading}
                        errors={dwriData.errors}
                    />
                </div>
                <div
                    role="tabpanel"
                    id="tabpanel-r1-report"
                    aria-labelledby="tab-:r1:-report"
                    hidden={activeTab !== "report"}
                >
                    <DwriReportTab />
                </div>
            </div>
        </div>
    );
};

export default DwriDataContainer;